exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.p-6[data-v-1dc8c682]{\n    padding: 1em;\n}\n\n", ""]);

// exports
